<div class="modal fade" [id]="helpModalId">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-title hyperion-t4">
          {{ languageService.getTranslation('MODAL.HELP.TITLE') | async }}
        </div>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="hyperion-t6 mb-3" [innerHtml]="sanitizer.bypassSecurityTrustHtml(languageService.getTranslation('MODAL.HELP.TEXT') | async)"></div>
        @switch (activeRoute) {
          @case ('profile') {
            @switch (subRoute) {
              @case ('view') {
                <app-profile-help></app-profile-help>
              }
              @default {
                <app-manage-profiles-help></app-manage-profiles-help>
              }
            }
          }
          @case ('profile-templates') {
            @switch (subRoute) {
              @case ('build') {
                <app-profile-builder-help></app-profile-builder-help>
              }
              @default {
                <app-profile-builder-management-help></app-profile-builder-management-help>
              }
            }
          }
          @case ('scheduler') {
            <app-scheduler-help></app-scheduler-help>
          }
          @default {
            <div class="hyperion-t6">
              There are no tutorials written for this page yet.
            </div>
          }
        }
      </div>
      <div class="modal-footer">
        <wdpr-button data-bs-dismiss="modal">
          {{ languageService.getTranslation('BUTTON.CLOSE') | async }}
        </wdpr-button>
      </div>
    </div>
  </div>
</div>
